import { render, staticRenderFns } from "./ListaRequisicaoProdutosSelecionadosMenu.vue?vue&type=template&id=1a9011d8&"
import script from "./ListaRequisicaoProdutosSelecionadosMenu.vue?vue&type=script&lang=js&"
export * from "./ListaRequisicaoProdutosSelecionadosMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VCard,VCardText,VChip,VMenu})
